import Header from "../../../sharedComponents/header/header";
import React from "react";
import { NnwClientModel } from "../../../../helpers/nnwClient";
import FirstName from "../../../sharedComponents/firstName/firstName";
import LastName from "../../../sharedComponents/lastName/lastName";
import NnwBeneficiary from "./nnwBeneficiary/nnwClientBeneficiary";
import Pesel from "../../../sharedComponents/pesel/pesel";
import { inject, observer } from "mobx-react";
import HeartAttackAndStroke from "./heartAttackAndStroke";
import { CalculateStore } from "../../../../stores/calculateStore";
import NnwAddress from "./nnwAddress/nnwAddress";

interface NnwInsuredProps {
  calculateStore?: CalculateStore;
  client: NnwClientModel;
  headerText: string;
}

export function NnwInsured(props: NnwInsuredProps) {
  return (
    <div className="section nnw-insured">
      <Header type="medium" mainHeader={props.headerText} />
      {isHeartAttackAndStrokeSelected() && < HeartAttackAndStroke client={props.client} />}
      <FirstName firstName={props.client.firstName} />
      <LastName lastName={props.client.lastName} />
      <Pesel pesel={props.client.pesel} />
      <NnwAddress client={props.client} />
      <NnwBeneficiary client={props.client} />
    </div>
  );

  function isHeartAttackAndStrokeSelected() {
    return props.calculateStore!.additionalInsurances.nnwHeartAttackAndStroke.checked;
  }
}

export default inject("calculateStore")(observer(NnwInsured));
